<div class="cyclerStatus__container" [class.compact]="compact">
  @for (star of stars; track star) {
    <ion-icon
      class="cyclerStatus__star"
      [src]="ICON.STAR"
      [color]="star"
      [size]="size"
      aria-hidden="true"
    />
  }
</div>
